// extracted by mini-css-extract-plugin
module.exports = {"compound_dialog":"styles_compound_dialog__3YVl4","put_modal_container":"styles_put_modal_container__1DNvv","btns":"styles_btns__11ZUZ"};